import { defineMessages, type IntlShape } from 'react-intl';
import type { JSONSchema } from '@plone/types';

const addSelectAlternativePreviewImage = ({
  schema,
  intl,
}: {
  schema: JSONSchema;
  intl: IntlShape;
}): JSONSchema => {
  schema.fieldsets[0].fields = [
    ...schema.fieldsets[0].fields,
    'use_alternative_preview_image',
  ];

  schema.properties['use_alternative_preview_image'] = {
    title: intl.formatMessage(messages.alternative_preview_image_title),
    type: 'boolean',
  };
  return schema;
};

export default addSelectAlternativePreviewImage;

const messages = defineMessages({
  alternative_preview_image_title: {
    id: 'alternative_preview_image_title',
    defaultMessage: 'Use alternative preview image',
  },
});
